import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";

// Accueil : membres présents au dojo sans payer + contrats terminés / paiements arrêtés → très en évidence.
export function DuesAlert() {
  const [rep, setRep] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/dues-attendance/report").then((r) => setRep(r.data)).catch(() => setRep(null)); }, []);
  if (!rep || !rep.stats) return null;
  const s = rep.stats;
  if (!s.still_coming && !s.contracts_ended && !s.payments_stopped) return null;
  return (
    <div className="mx-6 md:mx-8 lg:mx-10 mt-6 rounded-xl border border-rose-500/50 bg-rose-500/[0.07] p-4" data-testid="dues-alert">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-rose-300 font-semibold">Paiements · à ne pas manquer</p>
          <h3 className="text-zinc-100 font-bold mt-0.5" data-testid="dues-alert-title">
            {s.still_coming} membre{s.still_coming > 1 ? "s" : ""} présent{s.still_coming > 1 ? "s" : ""} au dojo sans paiement à jour
            {s.still_coming ? ` · ${Number(rep.total_due_est).toFixed(2).replace(".", ",")} $ estimés` : ""}
          </h3>
          <p className="text-xs text-zinc-400 mt-0.5">
            {s.payments_stopped} paiement{s.payments_stopped > 1 ? "s" : ""} arrêté{s.payments_stopped > 1 ? "s" : ""}/en retard · {s.contracts_ended} contrat{s.contracts_ended > 1 ? "s" : ""} terminé{s.contracts_ended > 1 ? "s" : ""}
            {s.still_coming ? ` · ${s.still_coming_with_card} avec carte au dossier · ${s.still_coming_no_stripe} sans dossier Stripe` : ""}
          </p>
        </div>
        <button onClick={() => navigate("/app/membres-paiements?tab=defaut")} className="shrink-0 px-3 py-1.5 rounded-lg bg-[#D90429] hover:bg-rose-500 text-white text-xs font-semibold" data-testid="dues-alert-open">
          Voir la liste + vérifier Stripe →
        </button>
      </div>
      {rep.still_coming.slice(0, 4).map((r) => (
        <div key={r.contract_id} className="mt-2 text-xs text-zinc-300 flex flex-wrap gap-x-3" data-testid={`dues-alert-row-${r.contract_id}`}>
          <b className="text-zinc-100">{r.full_name}</b><span>{r.reasons[0]}</span><span className="text-zinc-500">{r.presences_count} présence(s) · dernière {r.last_presence}</span>
          {r.stripe?.dashboard_url && <a href={r.stripe.dashboard_url} target="_blank" rel="noreferrer" className="text-[#C9A961] underline">Stripe {r.stripe.customer_id}</a>}
        </div>
      ))}
    </div>
  );
}
